module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9eb60af40878e5ef0e60f56a87123424.png";